import { SearchTerm } from "./SearchTerm";

const AccessGroupDeviceActionSearch: SearchTerm[] = [
    { 
        heading: "Name",
        accessor: "name",
        searchOnName: "setting.trnName",
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "setting.settingType.trnName",
        translationKey: "type"
    },
    {
        heading: "Device",
        accessor: "device",
        searchOnName: "deviceImprox.devName",
        translationKey: "device"
    }
];

export default AccessGroupDeviceActionSearch;
